/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AdvancedKeywordSearchResponseDto } from '../../models/advanced-keyword-search-response-dto';

export interface GetNestedAggs$Params {}

export function getNestedAggs(
  http: HttpClient,
  rootUrl: string,
  params?: GetNestedAggs$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<AdvancedKeywordSearchResponseDto>> {
  const rb = new RequestBuilder(rootUrl, getNestedAggs.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AdvancedKeywordSearchResponseDto>;
    })
  );
}

getNestedAggs.PATH = '/data-mart/advanced-search/nestedAggs';
